module.exports = __webpack_public_path__ + "img/morgan-and-mike-logo.8e3a7b13.png";